import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import ResultsListBody from "components/PatientManagement/Results/ResultsListBody";

export default function Results() {
  useEffect(() => {
    document.title = "Results";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <ResultsListBody />
    </main>
  );
}
